import Logger from "@/utils/Logger"
import { ThirdPartyIntegrationType } from "@/utils/enums/ThirdPartyIntegrationType"

const GOOGLE_VERIFICATION_META_NAME_DEFAULT = "google-site-verification"

interface VerificationMeta {
  name: string
  content: string
}

function attributeValue(html: string, attribute: string): string | undefined {
  return html.match(new RegExp(`(?:^|\\s)${attribute}\\s*=\\s*["']([^"']+)["']`, "i"))?.[1]?.trim()
}

// unhead's head API is structured-only, so turn the pasted <meta> into
// {name, content} (which also lets unhead escape the token).
export function extractVerificationMeta(sourceCode: string | null | undefined): VerificationMeta | null {
  const raw = sourceCode?.trim()
  if (!raw)
    return null

  const content = attributeValue(raw, "content")
  if (!content)
    return null

  const name = attributeValue(raw, "name")
  return { name: name || GOOGLE_VERIFICATION_META_NAME_DEFAULT, content }
}

// Server-side render so Google's JS-less verification fetcher reads the token;
// all other third-party types stay on the client plugin.
export function useSiteVerification(jobShop: JobShop | null) {
  const integrations = (jobShop?.thirdPartyIntegrations ?? [])
    .filter(integration => integration.scriptType === ThirdPartyIntegrationType.GOOGLE_SEARCH_CONSOLE_VERIFICATION)

  const meta: VerificationMeta[] = []
  for (const integration of integrations) {
    const parsed = extractVerificationMeta(integration.sourceCodeHead || integration.sourceCodeBody)
    if (parsed)
      meta.push(parsed)
    else if (import.meta.server)
      Logger().warn(`[useSiteVerification] could not parse GSC verification markup for integration "${integration.title}"`)
  }

  if (meta.length > 0)
    useServerHead({ meta })
}
